import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function FinalCTA() {
  return <section className="bg-navy px-3 py-4 text-center sm:px-6" data-id="element-49" data-mp="3udf8az5tp7i7">
      <div className="mx-auto max-w-xl" data-id="element-50" data-mp="c6ivdvtic587">
        <h2 className="text-lg font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-51" data-mp="c7k8e5u331sk">
          One last question
        </h2>
        <p className="mt-1 text-sm leading-snug text-white/85 sm:text-base" data-id="element-52" data-mp="87jq2a3v66g8">
          When you need to understand a neurological pathway, clinical sign or
          localization pattern... Do you immediately see how the anatomy and
          findings connect? Stop jumping between scattered references and
          memorizing neurological information without seeing the bigger
          picture. Follow the anatomy. Connect the findings. Understand the
          pattern.
        </p>
        <p className="mt-1 font-heading text-xs font-extrabold uppercase tracking-wide text-gold sm:text-sm" data-id="element-53" data-mp="14tdccir48mgx">
          Visualize. Connect. Understand.
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[240px] sm:max-w-[290px]" data-id="element-54" data-mp="2c5puhoei0zz0" />

        <p className="mt-2 font-heading text-base font-extrabold uppercase text-white sm:text-2xl" data-id="element-55" data-mp="2h37xky5u4kz3">
          🧠 NEUROLOGY VISUAL ATLAS™
        </p>
        <p className="mt-0.5 font-heading text-[0.65rem] font-semibold uppercase tracking-wide text-white/80 sm:text-xs" data-id="element-56" data-mp="2m1j7f8w4qvhb">
          The Complete Visual Study System for Neurology Students
        </p>
        <p className="mt-0.5 font-heading text-[0.65rem] font-semibold uppercase tracking-widest text-electric sm:text-xs" data-id="element-57" data-mp="2v38z8ftxbwfm">
          Visualize • Understand • Connect • Compare • Localize • Review
        </p>

        <div className="mx-auto mt-2 max-w-md" data-id="element-58" data-mp="34vex266ux82q">
          <p className="font-heading text-xs font-extrabold uppercase tracking-wide text-gold sm:text-sm" data-id="element-59" data-mp="39sootshpxvtq">
            🔥 GET THE COMPLETE SYSTEM TODAY
          </p>
          <div className="mt-1.5" data-id="element-60" data-mp="3it3a4ruonax8">
            <CTAButton label="⚡ GET NEUROLOGY VISUAL ATLAS™" data-id="element-61" data-mp="3iu4y1wwsrrwd" />
          </div>
          <p className="mt-1.5 text-[0.65rem] font-bold uppercase tracking-wide text-white/75 sm:text-xs" data-id="element-62" data-mp="1jntqzs9obvxa">
            Immediate Access • Digital Delivery 🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}